import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";

type GameContextType = {
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;

  isHelpPanelOpen: boolean;
  setHelpPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;

  isGameStarted: boolean;
  setGameStarted: React.Dispatch<React.SetStateAction<boolean>>;

  attempts: number;
  setAttempts: React.Dispatch<React.SetStateAction<number>>;

  time: number;
  setTime: React.Dispatch<React.SetStateAction<number>>;

  isTimerRunning: boolean;
  setIsTimerRunning: React.Dispatch<React.SetStateAction<boolean>>;

  roundState: "playing" | "success" | "finished";
  setRoundState: React.Dispatch<
    React.SetStateAction<"playing" | "success" | "finished">
  >;

  round: number;
  setRound: React.Dispatch<React.SetStateAction<number>>;
};

const GameContext = createContext<GameContextType | undefined>(undefined);

export const GameProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [message, setMessage] = useState<string>("Начни игру!");
  const [isHelpPanelOpen, setHelpPanelOpen] = useState<boolean>(false);
  const [isGameStarted, setGameStarted] = useState<boolean>(false); //запущена ли игра
  const [attempts, setAttempts] = useState<number>(0); // количество попыток в текущем раунде
  const [time, setTime] = useState(0); // время в секундах
  const [isTimerRunning, setIsTimerRunning] = useState(false); // запущен ли таймер
  const [round, setRound] = useState(1); // номер текущего раунда
  const [roundState, setRoundState] = useState<
    "playing" | "success" | "finished"
  >("playing"); // состояние текущего раунда: "playing", "success" или "finished"

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isTimerRunning) {
      interval = setInterval(() => {
        setTime((t) => t + 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isTimerRunning]);

  return (
    <GameContext.Provider
      value={{
        message,
        setMessage,
        isHelpPanelOpen,
        setHelpPanelOpen,
        isGameStarted,
        setGameStarted,
        attempts,
        setAttempts,
        time,
        setTime,
        isTimerRunning,
        setIsTimerRunning,
        roundState,
        setRoundState,
        round,
        setRound,
      }}
    >
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error("useGame must be used within a GameProvider");
  }
  return context;
};
